import { getFormValues, destroy } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

const defaultInitialState = {
	isBlacklistedIpsPopupShowed: false,
	blacklistedIps: []
};

const createForm = () => {
	const namespace = 'unacceptableConversions';

	const TOGGLE_FORM = `${namespace}-toggle-blacklisted-ips-form`;

	const SUBMIT_FORM_OK = `${namespace}-submit-blacklisted-ips-form-ok`;
	const SUBMIT_FORM_FAIL = `${namespace}-submit-blacklisted-ips-form-fail`;

	const FETCH_LIST_OK = `${namespace}-fetch-blacklisted-ips-ok`;
	const FETCH_LIST_NOT_OK = `${namespace}-fetch-blacklisted-ips-not-ok`;

	const DROP_IP_OK = `${namespace}-drop-blacklisted-ip-ok`;

	const initialState = { ...defaultInitialState };

	const actions = {
		toggleBlacklistedIpsForm: () => dispatch => {
			dispatch({ type: TOGGLE_FORM  });
			dispatch(actions.fetchBlacklistedIpsList());
		},
		submitBlacklistedIp: (formData) => (dispatch, getState) => {
			const data = { ...formData };

			return http({
				url: endpoints.CONVERSIONS.BLACKLISTED_IPS,
				method: 'post',
				data: data,
				actions: [ SUBMIT_FORM_OK, SUBMIT_FORM_FAIL ]
			})(dispatch).then(action => {
				if (action.type === SUBMIT_FORM_OK) {
					dispatch(destroy('blacklistedIpsForm'));
					dispatch(actions.fetchBlacklistedIpsList());
				}
			});
		},
		fetchBlacklistedIpsList: () => (dispatch, getState) => {
			return http({
				url: endpoints.CONVERSIONS.BLACKLISTED_IPS,
				method: 'get',
				actions: [ FETCH_LIST_OK, FETCH_LIST_NOT_OK ]
			})(dispatch);
		},
		removeBlacklistedIp: (ip) => (dispatch, getState) => {
			return http({
				url: endpoints.CONVERSIONS.BLACKLISTED_IPS,
				method: 'delete',
				data: { ip },
				actions: [ DROP_IP_OK ]
			})(dispatch)
				.then(() => {
					dispatch(actions.fetchBlacklistedIpsList());
				});
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state, isBlacklistedIpsPopupShowed: !state.isBlacklistedIpsPopupShowed
		}),
		[FETCH_LIST_OK]: (state, action) => ({
			...state, blacklistedIps: action.payload.data
		})
	};

	const selectors = {
		getBlacklistedFormData: state => {
			const formValues = getFormValues('blacklistedIpsForm')(state);
			if (!formValues) return {};

			return {
				...formValues,
				offers: formValues.offers && formValues.offers.map(i => i.value),
				countries: formValues.countries && formValues.countries.map(i => i.value),
				affiliate_id: state.affiliateProfile.affiliateId
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/blacklisted-ips-form/index.js